// Copies text to the clipboard. Resolves false, rather than throwing, when the
// browser has no clipboard API (older browsers, insecure origins) or refuses
// the write, so callers can fall back to showing the text for manual copying.
export const copyToClipboard = async (text) => {
  if (typeof navigator.clipboard?.writeText !== "function") {
    return false;
  }
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.warn("Failed to copy to clipboard", err);
    return false;
  }
};
